import type { IPenThemes } from '@ipen-portal/plugin-common-react';
import type { FC, PropsWithChildren } from 'react';

import {
  ipenPageThemes,
  IpenThemeProvider,
  ObservedScrollArea,
} from '@ipen-portal/plugin-common-react';
import { tss } from 'tss-react/mui';

import { HtmlHeaderTitle } from './components/HtmlHeaderTitle';

const useStyles = tss.withName('BackstagePage').create({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  scrollArea: {
    height: '100%',
    overflow: 'auto',
  },
});

type Props = {
  themeId: IPenThemes;
  title?: string;
};

export const IpenPage: FC<PropsWithChildren<Props>> = ({
  children,
  themeId,
  title,
}) => {
  const { classes } = useStyles();
  const selectedThemeId = ipenPageThemes.includes(themeId)
    ? themeId
    : 'default';
  return (
    <IpenThemeProvider themeId={selectedThemeId}>
      <HtmlHeaderTitle title={title} />
      <ObservedScrollArea className={classes.scrollArea}>
        <main className={classes.root}>{children}</main>
      </ObservedScrollArea>
    </IpenThemeProvider>
  );
};
